export const logger = { 
    info : (message) => {
        console.info(message);
    },
    error : (message) => { 
        console.error(message);
    }
};

